import { createApp } from 'vue'
import PracticeSession from '../components/PracticeSession.vue'

export function mountMistakes() {
  const el = document.getElementById('mistakes-app')
  if (!el) return

  const app = createApp(PracticeSession, {
    exerciseUrl: el.dataset.exerciseUrl,
    backUrl: el.dataset.backUrl,
    subscribed: el.dataset.subscribed === 'true',
    mistakesMode: true,
  })
  app.mount(el)
}
